<!--  -->
<template>
  <div style="padding: 20px;">
    <div>
      <el-select v-model="parmrs.department_id" filterable placeholder="请选择部门" @change="newqwr">
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <el-select v-model="parmrs.pitcher_id" :disabled="parmrs.department_id==''" filterable placeholder="请选择投手" style="margin-left: 20px;">
        <el-option
          v-for="item in optionstwo"
          :key="item.id"
          :label="item.admin_name"
          :value="item.id"
        />
      </el-select>
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        style="width: 300px;margin-left: 20px;"
        @change="handleDateChange"
      />
      <el-input v-model="parmrs.account_name" style="width: 300px;margin-left: 20px;" placeholder="请输入广告主名称" />
      <el-input v-model="parmrs.account_id" style="width: 300px;margin-left: 20px;" placeholder="请输入广告主ID" />
      <!-- <el-input v-model="parmrs.short_name" style="width: 300px;margin-left: 20px;" placeholder="请输入短剧名称" /> -->
      <el-button
        type="primary"
        icon="el-icon-search"
        style="margin-left: 20px;"
        @click="search"
      >搜索</el-button>
      <el-button
        type="primary"
        icon="el-icon-refresh-left"
        @click="reset"
      >重置</el-button>
    </div>
    <div>
      <!-- 汇总信息栏 -->
      <el-card shadow="never" class="summary-card">
        <div class="summary-container">
          <div class="summary-item">
            <div class="summary-label">广告主总数</div>
            <div class="summary-value">{{ reportData.total_account_num || 0 }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">短剧总数</div>
            <div class="summary-value">{{ reportData.total_short_num || 0 }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">新剧总数</div>
            <div class="summary-value">{{ reportData.total_new_short_num || 0 }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">总消耗</div>
            <div class="summary-value">{{ reportData.total_cost || 0 }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">总回收</div>
            <div class="summary-value">{{ reportData.total_income || 0 }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">总回收扣点</div>
            <div class="summary-value">{{ reportData.total_rebate_income || 0 }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">总回收ROI</div>
            <div class="summary-value">{{ reportData.total_income_roi || 0 }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">总回收扣点 ROI</div>
            <div class="summary-value">{{ reportData.total_rebate_roi || 0 }}</div>
          </div>
        </div>
      </el-card>
      <el-table
        :data="tableData"
        border
        style="width: 100%;margin-top: 20px;"
        row-key="id"
      >
        <!-- 主表字段 -->
        <el-table-column prop="department_name" label="部门名称" width="150" align="center" />
        <el-table-column prop="pitcher_name" label="投手名称" width="150" align="center" />
        <el-table-column prop="account_id" label="广告主数量" width="150" align="center" />
        <!-- <el-table-column prop="account_name" label="广告主名称" width="150" align="center" /> -->
        <el-table-column prop="income" label="回收" width="120" align="center" />
        <el-table-column prop="rebate_income" label="扣点回收" width="120" align="center" />
        <el-table-column prop="rebate_roi" label="扣点ROI" width="120" align="center" />
        <el-table-column prop="cost" label="消耗" align="center" />
        <el-table-column prop="short_name" label="短剧数量" align="center" />
        <el-table-column prop="short_type" label="新剧数量" align="center" />
        <el-table-column label="操作" align="center">
          <template scope="scope">
            <el-button type="primary" size="mini" @click="look(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
        <!-- 子表展开 -->
        <!-- <el-table-column type="expand">
          <template #default="props">
            <el-table
              :data="props.row.list"
              border
              size="mini"
              style="width: 100%; margin-left: 20px;"
            >
              <el-table-column prop="account_name" label="广告主名称" width="150" align="center" />
              <el-table-column prop="pitcher_name" label="投手名称" width="150" align="center" />
              <el-table-column prop="short_name" label="短剧名称" width="150" align="center" />
              <el-table-column prop="short_type" label="剧集类型" width="100" align="center" />
              <el-table-column prop="cost" label="消耗" width="100" align="center" />
              <el-table-column prop="income" label="回收" width="100" align="center" />
              <el-table-column prop="rebate_income" label="扣点回收" width="120" align="center" />
              <el-table-column prop="rebate_roi" label="扣点ROI" align="center" />
            </el-table>
          </template>
        </el-table-column> -->
      </el-table>
      <!-- <pagination-right
        :current-page="parmrs.page"
        :page-sizes="[10]"
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      /> -->
    </div>
  </div>
</template>

<script>
// 注意：此文件需要复制为 Native 版本
import { iaaMaterialReportdepartmentlist, iaapitcherindex, reportpitcherList } from '@/api/TKreleaseGroup.js'
// import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  name: 'Iaapitchernew',
  components: { /* PaginationRight */ },
  data() {
    return {
      options: [],
      optionstwo: [],
      parmrs: {
        page: 1,
        page_size: 10,
        department_id: '',
        pitcher_id: '',
        account_id: '',
        account_name: '',
        short_name: '',
        start_time: '',
        end_time: ''
      },
      dateRange: [],
      tableData: [],
      total: null,
      reportData: {}
    }
  },
  created() {

  },
  mounted() {
    // 初始化默认今天的日期
    const today = this.formatDate(new Date())
    this.dateRange = [today, today]
    this.parmrs.start_time = today
    this.parmrs.end_time = today
    this.list()
    this.getlist()
  },
  activated() {
    this.list()
    this.getlist()
  },
  methods: {
    list() {
      iaaMaterialReportdepartmentlist({ page: 1, page_size: 100 }).then((res) => {
        this.options = res.data.list
      })
    },
    newqwr() {
      iaapitcherindex({ page: 1, page_size: 100, department_id: this.parmrs.department_id }).then((res) => {
        this.parmrs.pitcher_id = ''
        this.optionstwo = []
        this.optionstwo = res.data.list
      })
    },
    search() {
      this.parmrs.page = 1
      this.getlist()
    },
    reset() {
      this.parmrs.page = 1
      this.parmrs.department_id = ''
      this.parmrs.pitcher_id = ''
      this.parmrs.account_id = ''
      this.parmrs.account_name = ''
      this.parmrs.short_name = ''
      this.parmrs.optionstwo = []
      this.parmrs.start_time = ''
      this.parmrs.end_time = ''
      this.dateRange = []
      this.getlist()
    },
    getlist() {
      reportpitcherList(this.parmrs).then((res) => {
        console.log(res)
        this.reportData = res.data
        this.tableData = res.data.list
        this.total = res.data.count
      })
    },
    // 分页
    fetchPageSize(e) {
      this.parmrs.page_size = e
      this.getlist()
    },
    fetchCurrentPage(e) {
      this.parmrs.page = e
      this.getlist()
    },
    look(row) {
      this.$router.push({ path: '/iaapeoplelist/index', query: { id: row.pitcher_id, dateRange: this.dateRange, account_name: this.parmrs.account_name, account_id: this.parmrs.account_id, short_name: this.parmrs.short_name }})
    },
    handleDateChange(val) {
      if (val && val.length === 2) {
        this.parmrs.start_time = val[0]
        this.parmrs.end_time = val[1]
      } else {
        this.parmrs.start_time = ''
        this.parmrs.end_time = ''
      }
    },
    // 格式化日期为 yyyy-MM-dd
    formatDate(date) {
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      return `${y}-${m}-${d}`
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.summary-card {
  background-color: #f9fafc;
  margin-bottom: 10px;
  margin-top: 20px;
}
.summary-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}
.summary-item {
  flex: 1;
  min-width: 120px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  padding: 10px 15px;
  text-align: center;
}
.summary-label {
  font-size: 13px;
  color: #909399;
}
.summary-value {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  margin-top: 10px;
}
</style>
